import { Button, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { Alias } from '../../aliases/types';
import { useSetAliasStatus } from '../hooks/useSetAliasStatus';

// FNP-2137: disable or enable any alias, after a confirm step. Disabling sends the
// alias's inbound mail to alias.not.found, as if the alias did not exist (FNP-2172).
export const AliasStatusToggleButton = ({ alias }: { alias: Alias }) => {
    const { mutate, isPending } = useSetAliasStatus();
    const disabling = alias.aliasStatus !== 'DISABLED';
    const label = disabling ? 'Disable' : 'Enable';

    const confirm = () => modals.openConfirmModal({
        title: `${label} alias ${alias.name}?`,
        children: (
            <Text size="sm">
                {disabling
                    ? `Mail sent to ${alias.name} will be handled as if the alias did not exist. You can enable it again later.`
                    : `${alias.name} will receive mail again.`}
            </Text>
        ),
        labels: { confirm: `${label} alias`, cancel: 'Cancel' },
        confirmProps: { color: disabling ? 'red' : 'green' },
        onConfirm: () => mutate({ id: alias.id, aliasStatus: disabling ? 'DISABLED' : 'ENABLED' })
    });

    return (
        <Button size="xs" variant="light" color={disabling ? 'red' : 'green'} loading={isPending} onClick={confirm}>
            {label}
        </Button>
    );
};
